import * as React from "react"
import { RadioGroup as RadioGroupPrimitive } from "radix-ui"

import { cn } from "@/lib/utils"

function RadioGroup({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Root>) {
  return (
    <RadioGroupPrimitive.Root
      data-slot="radio-group"
      className={cn("grid w-full gap-2", className)}
      {...props}
    />
  )
}

function RadioGroupItem({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Item>) {
  const isGrayStyledRadio =
    "data-broker-asset-class-radio" in props ||
    "data-strategy-compose-mode-radio" in props

  const isAccountSettingsRadio = "data-account-settings-radio" in props

  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(
        "group/radio-group-item peer relative flex aspect-square size-4 shrink-0 rounded-full border border-input outline-none after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 aria-invalid:aria-checked:border-primary dark:bg-input/30 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40",
        isAccountSettingsRadio
          ? "border-gray-500 bg-background data-checked:border-[color:var(--brand-tropical-surf)] data-checked:bg-[color:var(--brand-tropical-surf)] data-checked:text-white data-[state=checked]:border-[color:var(--brand-tropical-surf)] data-[state=checked]:bg-[color:var(--brand-tropical-surf)] data-[state=checked]:text-white dark:border-white/70 dark:bg-transparent dark:data-checked:border-[color:var(--brand-tropical-surf)] dark:data-checked:bg-[color:var(--brand-tropical-surf)] dark:data-[state=checked]:border-[color:var(--brand-tropical-surf)] dark:data-[state=checked]:bg-[color:var(--brand-tropical-surf)]"
          : isGrayStyledRadio
          ? "border-[#6b7280] bg-background data-checked:border-[#6b7280] data-checked:bg-[#6b7280] data-checked:text-white data-[state=checked]:border-[#6b7280] data-[state=checked]:bg-[#6b7280] data-[state=checked]:text-white dark:bg-background dark:data-checked:bg-[#6b7280] dark:data-[state=checked]:bg-[#6b7280]"
          : "data-checked:border-primary data-checked:bg-primary data-checked:text-primary-foreground data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:data-checked:bg-primary dark:data-[state=checked]:bg-primary",
        className
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        data-slot="radio-group-indicator"
        className="flex size-4 items-center justify-center"
      >
        <span
          className={cn(
            "absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2 rounded-full",
            isAccountSettingsRadio || isGrayStyledRadio ? "bg-white" : "bg-primary-foreground"
          )}
        />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  )
}

export { RadioGroup, RadioGroupItem }
